import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { LegislationRecipient, LegislationGroup, LegislationItem, LegislationRecipientGroup, LegislationRecipientVM, LegislationRecipientByGroup, LegislationItemRecipient } from 'app/legislation/legislation-items/legislation';

@Injectable({ providedIn: 'root' })
export class LegislationService {
    legislationUrl = '';
    legislationItemRecipientsUrl = '';
    legislationGroupsUrl = '';
    legislationRecipientUrl = '';
    legislationRecipientGroupsUrl = '';

    legislationItemsDS = new BehaviorSubject<LegislationItem[]>([]);
    currentLegislationItems: Observable<any>;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.legislationUrl = baseUrl + 'api/legislation/items';
        this.legislationItemRecipientsUrl = baseUrl + 'api/legislationItemRecipient/itemrecipients';
        this.legislationGroupsUrl = baseUrl + 'api/legislationGroup/groups';
        this.legislationRecipientUrl = baseUrl + 'api/legislationRecipient/recipients';
        this.legislationRecipientGroupsUrl = baseUrl + 'api/legislationRecipientGroup/recipientGroups';

        // this.getLegislationItems();
    }

    changeLegislationItems(legsislationItems: LegislationItem[]) {
        this.legislationItemsDS.next(legsislationItems);
    }

    //#region - METHODS

    //#region - Legislation Items
    getLegislationItems() {
        // this.http.get<LegislationItem[]>(this.legislationUrl).subscribe((data: LegislationItem[]) => {
        //     this.legislationItemsDS.next(data);
        // });
        return this.http.get<LegislationItem[]>(this.legislationUrl);
    }

    getLegislationItemById(id: number): Observable<LegislationItem> {
        return this.http.get<LegislationItem>(`${this.legislationUrl}/${id}`);
    }

    createLegislationItem(params: LegislationItem): Observable<LegislationItem> {
        return this.http.post<LegislationItem>(this.legislationUrl, params);
    }

    createLegislationItemDetails(params: LegislationItem): Observable<LegislationItem> {
        return this.http.post<LegislationItem>(this.legislationUrl + '/details', params);
    }

    updateLegislationItem(id: number, legislationItem: LegislationItem) {
        return this.http.put(`${this.legislationUrl}/${id}`, legislationItem);
    }

    updateLegislationItemDetails(id: number, legislationItem: LegislationItem) {
        return this.http.put(`${this.legislationUrl}/${id}/details`, legislationItem);
    }

    deleteLegislationItem(id: number): Observable<LegislationItem> {
        return this.http.delete<LegislationItem>(`${this.legislationUrl}/${id}`);
    }
    //#endregion

    // #region - Legislation Item Recipients
    getLegislationItemRecipientsByItemId(id: number): Observable<LegislationItemRecipient[]> {
        return this.http.get<LegislationItemRecipient[]>(`${this.legislationItemRecipientsUrl}/byId`, { params: { legislationItemId: id.toString() }});
    }
    // #endregion

    //#region - Legislation Recipients
    getLegislationRecipients(): Observable<LegislationRecipientVM[]> {
        return this.http.get<LegislationRecipientVM[]>(this.legislationRecipientUrl);
    }

    getLegislationRecipientById(id: number): Observable<LegislationRecipient> {
        return this.http.get<LegislationRecipient>(`${this.legislationRecipientUrl}/${id}`);
    }

    getLegislationRecipientVMById(id: number): Observable<LegislationRecipientVM> {
        return this.http.get<LegislationRecipientVM>(`${this.legislationRecipientUrl}/recipientsVM/${id}`);
    }

    getLegislationRecipientsByGroups(): Observable<LegislationRecipientByGroup[]> {
        return this.http.get<LegislationRecipientByGroup[]>(`${this.legislationRecipientUrl}/bygroup`);
    }

    createLegislationRecipient(params: LegislationRecipient): Observable<LegislationRecipient> {
        return this.http.post<LegislationRecipient>(this.legislationRecipientUrl, params);
    }

    updateLegislationRecipient(id: number, recipient: LegislationRecipient) {
        return this.http.put(`${this.legislationRecipientUrl}/${id}`, recipient);
    }

    deleteLegislationRecipient(id: number): Observable<LegislationRecipient> {
        return this.http.delete<LegislationRecipient>(`${this.legislationRecipientUrl}/${id}`);
    }
    //#endregion

    //#region - Legislation Groups
    getLegislationGroups() {
        return this.http.get<LegislationGroup[]>(this.legislationGroupsUrl);
    }

    getLegislationGroupById(id: number): Observable<LegislationGroup> {
        return this.http.get<LegislationGroup>(`${this.legislationGroupsUrl}/${id}`);
    }

    createLegislationGroup(params: LegislationGroup): Observable<LegislationGroup> {
        return this.http.post<LegislationGroup>(this.legislationGroupsUrl, params);
    }

    updateLegislationGroup(id: number, legislationGroup: LegislationGroup) {
        return this.http.put(`${this.legislationGroupsUrl}/${id}`, legislationGroup);
    }

    deleteLegislationGroup(id: number): Observable<LegislationGroup> {
        return this.http.delete<LegislationGroup>(`${this.legislationGroupsUrl}/${id}`);
    }

    //#endregion

    //#region - Legislation Recipient Groups
    getLegislationRecipientGroups() {
        return this.http.get<LegislationRecipientGroup[]>(this.legislationRecipientGroupsUrl);
    }

    getLegislationRecipientGroupsByRecipientId(id: number): Observable<LegislationRecipientGroup[]> {
        return this.http.get<LegislationRecipientGroup[]>(`${this.legislationRecipientGroupsUrl}`, { params: { recipientId: id.toString() }});
    }

    getLegislationRecipientGroupById(id: number): Observable<LegislationRecipientGroup> {
        return this.http.get<LegislationRecipientGroup>(`${this.legislationRecipientGroupsUrl}/${id}`);
    }

    createLegislationRecipientGroup(params: LegislationRecipientGroup): Observable<LegislationRecipientGroup> {
        return this.http.post<LegislationRecipientGroup>(this.legislationRecipientGroupsUrl, params);
    }

    updateLegislationRecipientGroup(id: number, legislationRecipientGroup: LegislationRecipientGroup) {
        return this.http.put(`${this.legislationRecipientGroupsUrl}/${id}`, legislationRecipientGroup);
    }

    deleteLegislationRecipientGroup(id: number): Observable<LegislationRecipientGroup> {
        return this.http.delete<LegislationRecipientGroup>(`${this.legislationRecipientGroupsUrl}/${id}`);
    }
    //#endregion


    //#endregion
}
